var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/scroll-to-button.tsx";
import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import Icon from 'soapbox/components/icon';
import { Text } from 'soapbox/components/ui';
import { useSettings } from 'soapbox/hooks';
/** Floating new post counter above timelines, clicked to scroll to top. */
const ScrollToButton = ({
  onClick,
  count,
  message,
  to,
  autoloadThreshold = 50
}) => {
  const intl = useIntl();
  const settings = useSettings();
  const timer = React.useRef(null);
  const autoload = settings.get('autoloadTimelines') === true;
  const getScrollTop = React.useCallback(() => {
    return (document.scrollingElement || document.documentElement).scrollTop;
  }, []);
  const maybeUnload = React.useCallback(() => {
    // we need to add a timer since there is a delay between content render and
    // scroll top calculation. Without it, new content is always loaded because
    // scrollTop is 0 at first.
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (count > 0 && autoload && getScrollTop() <= autoloadThreshold) {
        onClick();
      }
      timer.current = null;
    }, 1000);
  }, [count, autoload, getScrollTop, autoloadThreshold, onClick]);
  const handleClick = () => {
    onClick();
    to.current.scrollIntoView({
      block: 'start'
    });
  };
  const root = useRef(null);
  useEffect(() => {
    maybeUnload();
  }, [maybeUnload]);
  const visible = React.useMemo(() => count > 0, [count]);
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    ref: root,
    className: "left-1/2 -translate-x-1/2 fixed top-2 z-50",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "flex items-center bg-primary-600 hover:bg-primary-700 hover:scale-105 active:scale-100 transition-transform text-white rounded-full px-4 py-2 space-x-1.5 cursor-pointer whitespace-nowrap",
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/arrow-bar-to-up.svg'),
    fixedWidth: 8,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Text, {
    theme: "inherit",
    size: "xs",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }, intl.formatMessage(message, {
    count
  }))));
};
export default ScrollToButton;